/**
 * ========================================================
 * Description: A checkbox web control
 * Creation Date: ?
 * Author: ?
 * ========================================================
 * Revision History
 * ========================================================
 * Rev     Date        Author      Task        Description
 * ========================================================
 * 1       ?           ?           ?           Created
 * ========================================================
 **/
var EditorDevExtremeCheckBox = React.createClass({
    getInitialState: function () {
        return {};
    },
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.value != this.state.value) {
            this.state.value = nextProps.value;
            this.state.element.dxCheckBox('instance').option("value", this.state.value);
        }
    },
    componentDidMount:function()
    {
        var context = this;
        this.state.value = this.props.value;
        this.state.element = $(this.domElement).dxCheckBox({
            readOnly: this.props.readOnly,
            value: this.state.value,
            text: this.props.text,
            onValueChanged: function(data) {
                context.state.value = data.value;
                context.props.onChange(context.state.value);
                context.props.onBlur();
            }
        });
    },
    render: function() {
        var context = this;
        return <div ref={function(ref){context.domElement = ref}} />;
    }
});
